import { render } from "./DoubleRangeSlider.vue?vue&type=template&id=67a54a2a&scoped=true"
import script from "./DoubleRangeSlider.vue?vue&type=script&lang=js"
export * from "./DoubleRangeSlider.vue?vue&type=script&lang=js"

import "./DoubleRangeSlider.vue?vue&type=style&index=0&id=67a54a2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a54a2a"]])

export default __exports__